import { render } from "./codigovestimenta_ingles.vue?vue&type=template&id=18450a0f&scoped=true"
import script from "./codigovestimenta_ingles.vue?vue&type=script&lang=js"
export * from "./codigovestimenta_ingles.vue?vue&type=script&lang=js"

import "./codigovestimenta_ingles.vue?vue&type=style&index=0&id=18450a0f&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-18450a0f"]])

export default __exports__